import { useTranslation } from 'react-i18next'

const Copyright = () => {
  const { currentLanguage } = useLanguageStore()
  const { t } = useTranslation()

  return (
    <div className="relative box-border flex min-h-[50px] w-full items-center justify-end bg-[#333] px-[24px] py-[12px] sm:px-[120px] sm:py-0">
      <div
        style={{ fontSize: currentLanguage === 'en' ? '12px' : '14px' }}
        className="pointer-events-none absolute left-1/2 w-full max-w-[calc(100%-48px)] -translate-x-1/2 text-center text-[#999999] sm:max-w-[70%]"
      >
        {t('footer.copyright')} © {t('footer.company')}
      </div>
      <div className="relative z-[1] text-center text-[14px] text-[#fff] sm:text-right">{t('footer.support')}</div>
    </div>
  )
}

export default Copyright
